module.exports = __webpack_public_path__ + "static/img/32.e7a961c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/32.jpg
// module id = urU0
// module chunks = 0